// What the setup screen's "that's me" button is offering for a given roster row.
import type { Player } from "./types.js";

export type SeatOffer =
  /** The organiser is already playing as this row — tapping stops. */
  | "yours"
  /** Nobody holds this name; tapping takes it. */
  | "free"
  /** A device holds this name; tapping needs a confirmation first. */
  | "takeover";

/**
 * Whether some device holds this name.
 *
 * `claimedAt` cannot answer this on its own — the organiser's own seat sets it too,
 * with no token behind it — so the server sends `joined` and this only falls back to
 * the old reading when it is absent (a snapshot cached before that field existed).
 */
function joinedOnADevice(player: Pick<Player, "claimedAt" | "joined">): boolean {
  return player.joined ?? player.claimedAt != null;
}

/**
 * Never returns "no": a row is always either yours, free, or takeable with a warning.
 *
 * The bug this replaces disabled the button whenever `claimedAt` was set, which the
 * organiser's own seat does. An organiser whose seat had been announced and then
 * dropped — most commonly by joining as themselves from the invite link, which moves
 * the hold to that phone — found their own name greyed out with nothing to tap, on
 * either the taking or the releasing side.
 */
export function seatOffer(
  player: Pick<Player, "id" | "claimedAt" | "joined">,
  seatId: string | null,
): SeatOffer {
  if (player.id === seatId) return "yours";
  return joinedOnADevice(player) ? "takeover" : "free";
}
